import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-content',
  templateUrl: './reset-content.component.html',
  styleUrls: ['./reset-content.component.scss'],
})
export class ResetContentComponent implements OnInit {
  @Input() inputForm: FormGroup;

  constructor() {
  }

  ngOnInit() {
    this.inputForm.addControl('code', new FormControl('', [Validators.required]));
  }
}
